import { UserBM } from '@bm-js/atlascloud-shared'

export type AuthState = {
  token?: string
  user?: UserBM
  isAuthenticating?: boolean
}

export enum AuthActionType {
  mergeState = 'MERGE_STATE',
  replaceState = 'REPLACE_STATE',
}

export type AuthAction = {
  type: AuthActionType
  data: Partial<AuthState>
}

type AuthReducer = (state: AuthState, action: AuthAction) => AuthState

const mergeState: AuthReducer = (state, { data }) => {
  return { ...state, ...data }
}

const replaceState: AuthReducer = (_, { data }) => {
  return data
}

const authReducers: Record<AuthActionType, AuthReducer> = {
  [AuthActionType.mergeState]: mergeState,
  [AuthActionType.replaceState]: replaceState,
}

export const authReducer = (
  state: AuthState,
  action: AuthAction
): AuthState => {
  return authReducers[action.type](state, action)
}
